var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBussinessGlobusimg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.874 30.31C49.3362 26.1347 48.5355 21.9167 46.5755 18.2011C44.6154 14.4856 41.5861 11.4433 37.8789 9.46738C34.1718 7.49149 29.9572 6.67284 25.7799 7.11724C21.6027 7.56164 17.6547 9.24865 14.4462 11.9603C11.2377 14.6719 8.91622 18.2834 7.78174 22.3282C6.64727 26.3729 6.75195 30.665 8.08227 34.6496C9.41259 38.6343 11.9074 42.1284 15.2442 44.6803C18.5811 47.2323 22.6066 48.7248 26.8006 48.965M8.39996 21H47.6M8.39996 35H40.8333",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8332 7C22.9023 13.2991 20.8184 20.575 20.8184 28C20.8184 35.425 22.9023 42.7009 26.8332 49M29.1665 7C34.373 15.343 36.2948 25.3225 34.5589 35.0023M34.9999 44.3333L39.6665 49L48.9999 39.6667",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBussinessGlobusimg);
export default __webpack_public_path__ + "static/media/bussiness_globusimg.d391235004367b48ab16d9a2a6b638aa.svg";
export { ForwardRef as ReactComponent };